import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { addNewTransfer, updateTransfer } from '../../../../slices/transfer/thunk';
import { setRequireCloseModal } from '../../../../slices/transfer/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GeneralSelect from '../../../../Components/General/Selects/GeneralSelect';
import { getTransferCategoryList, getTransferCompanyList, getTransferTypeList } from '../../../../helpers/transfer/backend_helper';
import { Files } from '../../../FileManager/Files';
import { default as LocalFiles } from '../../../FilesLocal/Files';
import useFileType from '../../../../Components/Hooks/useFileTypeHooks';
import { uploadFile } from '../../../../slices/thunks';
import UploadOneFileModal from '../../../FilesLocal/Modal/UploadOneFileModal';
import OSelect from '../../../../Components/OElements/OSelect';
import { getTransferTypeListByCompany } from '../../../../slices/transferType/thunk';
import OInput from '../../../../Components/OElements/OInput';

const TransferForm = ({
	dataTransfer,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);
	const [localFiles, setLocalFiles] = useState([]);
	const [newDocumentId, setNewDocumentId] = useState(null);
	const { file_type } = useFileType('RES');
	const [modalUploadOneFile, setModalUploadOneFile] = useState(false);


	const [organicCheck, setOrganicCheck] = useState(dataTransfer.organic);
	const [disabledCheck, setDisabledCheck] = useState(dataTransfer.disable);

	const [types, setTypes] = useState([]);
	const [transferTypeKey, setTransferTypeKey] = useState(`transfer_type || ''}`);


	const selectorTransfer = createSelector(
		state => state.Transfers,
		transfer => ({
			isAdding: transfer.isAdding,
			isAdded: transfer.isAdded,
			isUpdating: transfer.isUpdating,
			isUpdated: transfer.isUpdated,
			isLoadingList: transfer.isLoadingList,
			requireCloseModal: transfer.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorTransfer);

	const selectorTransferType = createSelector(
		state => state.TransferType,
		data => ({
			transferTypeListSelect: data.transferTypeListSelect
		})
	);

	const { transferTypeListSelect } = useSelector(selectorTransferType);


	function handleToggleModalUploadOneFile() {
		setModalUploadOneFile(!modalUploadOneFile);
	}

	const [selectedTransferCategory, setSelectedTransferCategory] = useState(null);
	const handleTransferCategorySelected = (optionSelected) => {
		setSelectedTransferCategory(optionSelected);
	};

	const [selectedTransferCompany, setSelectedTransferCompany] = useState(null);
	const handleTransferCompanySelected = (optionSelected) => {
		setSelectedTransferCompany(optionSelected);
	};

	const [selectedTransferType, setSelectedTransferType] = useState(null);
	const handleTransferTypeSelected = (optionSelected) => {
		setSelectedTransferType(optionSelected);
	};


	useEffect(() => {
		if (selectedTransferCompany) {
			dispatch(getTransferTypeListByCompany(selectedTransferCompany._id));
		}
	}, [selectedTransferCompany]);


	useEffect(() => {
		setTypes(transferTypeListSelect)
		setTransferTypeKey(`transfer_type_${selectedTransferCompany?._id || ''}`);
	}, [transferTypeListSelect]);




	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			patent: dataTransfer.patent || '',
			name: dataTransfer.name || '',
			transfer_category_id: '',
			transfer_company_id: '',
			transfer_type_id: ''
		},
		validationSchema: Yup.object({
			transfer_category_id: Yup.string().required('Campo requerido'),
			transfer_company_id: Yup.string().required('Campo requerido'),
			name: Yup.string().nullable(),
			patent: Yup.string().required('Campo requerido')
				.min(6, 'Debe contener 6 caracteres alfanuméricos.')
				.max(6, 'Debe contener 6 caracteres alfanuméricos.'),
			transfer_type_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			let folder_id = null;
			let document_ids = [];
			if (isEdit && !dataTransfer?.folder_id || !isEdit) {
				const folderPath = `/Logística/${selectedTransferCompany.name}/Transporte ${selectedTransferCategory.name}/${values.patent}`;

				for (const item of localFiles) {
					const formData = new FormData();
					formData.append('file', item.file);
					try {
						const responseUploadFile = await dispatch(uploadFile({ file_path: folderPath, file_type_id: file_type._id, formData: formData })).unwrap();
						if (!folder_id) {
							folder_id = responseUploadFile.folder._id;
						}
						document_ids.push(responseUploadFile._id);
					} catch (err) {
						setIsLoading(false);
						console.error('Error al subir archivo:', err);
					}
				};
			}

			if (isEdit) {
				const updatedTransfer = {
					_id: dataTransfer._id,
					transfer_category_id: values.transfer_category_id,
					transfer_type_id: values.transfer_type_id,
					transfer_company_id: values.transfer_company_id,
					patent: values.patent,
					name: values.name,
					disabled: (disabledCheck ? true : false),
					folder_id: (
						dataTransfer.folder_id
							? dataTransfer.folder_id
							: folder_id
					),
					document_ids: (
						dataTransfer.document_ids
							? dataTransfer.document_ids
							: document_ids
					)
				}
				dispatch(updateTransfer(updatedTransfer));
			} else {
				const newTransfer = {
					transfer_category_id: values.transfer_category_id,
					transfer_type_id: values.transfer_type_id,
					transfer_company_id: values.transfer_company_id,
					patent: values.patent,
					name: values.name,
					disabled: (disabledCheck ? true : false),
					folder_id: folder_id,
					document_ids: document_ids
				}
				dispatch(addNewTransfer(newTransfer));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);



	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={4}>
								<OInput
									name='patent'
									label='Patente o Matrícula'
									type='text'
									validation={validation}
									isRequired={true}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OInput
									name='name'
									label='Nombre'
									type='text'
									validation={validation}
									classNameLabel='form-label'
									classNameInput='form-control'
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={`transferCategory${dataTransfer?.transfer_category_id}` || ''}
									label='Categoría de Transporte'
									id='transfer_category_id'
									name='transfer_category_id'
									isRequired={true}
									value={dataTransfer?.transfer_category_id || ''}
									requestApi={() => getTransferCategoryList()}
									onSelect={(item) => handleTransferCategorySelected(item)}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={`transferCompany${dataTransfer?.transfer_company_id}` || ''}
									label='Empresa de Transporte'
									id='transfer_company_id'
									name='transfer_company_id'
									isRequired={true}
									value={dataTransfer?.transfer_company_id || ''}
									requestApi={() => getTransferCompanyList()}
									onSelect={(item) => handleTransferCompanySelected(item)}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={transferTypeKey}
									label='Tipo de Transporte'
									id='transfer_type_id'
									name='transfer_type_id'
									isRequired={true}
									value={dataTransfer?.transfer_type_id || ''}
									onSelect={(item) => handleTransferTypeSelected(item)}
									validation={validation}
									itemsSelect={types}
								/>
							</Col>
							<div className='d-flex gap-3 pt-3'>
								<div>
									{isEdit && (
										<FormGroup className='d-flex align-items-center'>
											<Label className=''>
												<div className='d-flex'>
													<Input
														type="checkbox"
														checked={disabledCheck}
														onChange={(e) => setDisabledCheck(e.target.checked)}
													/>
													<div className='px-1'>
														¿Registro inactivo?
													</div>
												</div>
											</Label>
											{validation.touched.disabled &&
												validation.errors.disabled ? (
												<FormFeedback type='invalid'>
													{validation.errors.disabled}
												</FormFeedback>
											) : null}
										</FormGroup>
									)}
								</div>
							</div>
						</Row>
					</TabPane>
					<TabPane tabId={'2'}>
						<Row className='g-3'>
							{
								(isEdit && dataTransfer.folder_id ?

									<React.Fragment>
										<UploadOneFileModal
											isOpen={modalUploadOneFile}
											folderId={dataTransfer.folder_id}
											fileTypeId={file_type?._id}
											handleToggleModal={handleToggleModalUploadOneFile}
											handleNewDocumentId={setNewDocumentId}
										/>
										<Files
											key={`${newDocumentId}` || ''}
											current_folder={{ _id: dataTransfer?.folder_id }}
											has_folders={true}
											handleFile={() => handleToggleModalUploadOneFile()}
										/>
									</React.Fragment>
									:
									<LocalFiles
										localFiles={localFiles}
										handleLocalFiles={setLocalFiles}
										folderId={(
											dataTransfer?.folder_id
												? dataTransfer?.folder_id :
												null
										)}
										fileTypeId={file_type?._id}
									/>
								)
							}
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isAdding ||
							isUpdating ||
							isLoading
						}
					>
						{
							isAdding ||
								isUpdating ||
								isLoading
								? (
									<i className='label-icon'><Spinner size='sm' /></i>
								) : <i className="ri-save-3-line label-icon"></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Transporte
					</button>
				</div>
			</div>
		</Form>
	);
};

export default TransferForm;
